'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.updateModuleApp = updateModuleApp;
exports.updateModuleAct = updateModuleAct;
exports.updateModule = updateModule;
exports.loadModuleApp = loadModuleApp;
exports.loadModuleAct = loadModuleAct;
exports.loadModule = loadModule;
exports.loadAllModules = loadAllModules;
exports.isLoaded = isLoaded;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* REDUX MAINTAIN MODULES PAGE */

/* eslint-disable */
var LOAD_ALL = 'LOAD_ALL';
var LOAD_ALL_SUCCESS = 'LOAD_ALL_SUCCESS';
var LOAD_ALL_FAIL = 'LOAD_ALL_FAIL';
var UPDATE_APPLICATION = 'UPDATE_APPLICATION';
var UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
var UPDATE_APPLICATION_FAIL = 'UPDATE_APPLICATION_FAIL';
var LOAD_APPLICATION = 'LOAD_APPLICATION';
var LOAD_APPLICATION_SUCCESS = 'LOAD_APPLICATION_SUCCESS';
var LOAD_APPLICATION_FAIL = 'LOAD_APPLICATION_FAIL';

var UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS';
var UPDATE_ACT_SUCCESS = 'UPDATE_ACT_SUCCESS';
var LOAD_ACT_SUCCESS = 'LOAD_ACT_SUCCESS';

var initialState = {
  loaded: false,
  updating: false,
  updateError: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case LOAD_ALL:
    case LOAD_APPLICATION:
    case UPDATE_APPLICATION:
      return (0, _extends6.default)({}, state, {
        updating: true
      });

    case LOAD_ALL_SUCCESS:
      return (0, _extends6.default)({}, state, {
        loaded: true,
        data: action.result.data
      });
    case LOAD_ALL_FAIL:
      return (0, _extends6.default)({}, state, {
        loaded: false
      });

    case LOAD_APPLICATION_SUCCESS:
    case UPDATE_APPLICATION_SUCCESS:
      var mod = action.result.module;
      var app = action.result.app;

      return (0, _extends6.default)({}, state, {
        updating: false,
        data: (0, _extends6.default)({}, state.data, (0, _defineProperty3.default)({}, mod, (0, _extends6.default)({}, state.data[mod], (0, _defineProperty3.default)({}, app, action.result.data))))
      });
    case UPDATE_MODULE_SUCCESS:
      var modu = action.result.module;
      var complete = false;
      if (action.result.data.numAppCompleted >= action.result.data.numAppTotal) {
        complete = true;
      }

      return (0, _extends6.default)({}, state, {
        updating: false,
        data: (0, _extends6.default)({}, state.data, (0, _defineProperty3.default)({}, modu, (0, _extends6.default)({}, state.data[modu], {
          numAppCompleted: action.result.data.numAppCompleted,
          isComplete: complete
        })))
      });
    case LOAD_ACT_SUCCESS:
    case LOAD_APPLICATION_FAIL:
    case UPDATE_APPLICATION_FAIL:
      return (0, _extends6.default)({}, state, {
        updating: false,
        updatingError: action.error
      });
    default:
      return state;
  }
}

/*
Given module id and application id, passes the state to update the application
*/
function updateModuleApp(userId, moduleId, appId, state) {
  var url = '/module' + moduleId + '/app' + appId + '/update';

  console.log(userId + ' ' + moduleId + ' ' + appId);
  console.log(state);
  return {
    types: [UPDATE_APPLICATION, UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION_FAIL],
    promise: function promise(client) {
      return client.post(url, {
        data: {
          userId: userId,
          moduleId: moduleId,
          appId: appId,
          state: state
        }
      });
    }
  };
}

function updateModuleAct(userId, moduleId, appId, state) {
  var url = '/module' + moduleId + '/act' + appId + '/update';

  console.log(state);
  return {
    types: [UPDATE_APPLICATION, UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION_FAIL],
    promise: function promise(client) {
      return client.post(url, {
        data: {
          userId: userId,
          moduleId: moduleId,
          appId: appId,
          state: state
        }
      });
    }
  };
}

// modState contains numAppCompleted, numAppTotal, isCompleteShown
function updateModule(userId, moduleId, modState) {
  var url = '/module' + moduleId + '/update';

  return {
    types: [UPDATE_APPLICATION, UPDATE_MODULE_SUCCESS, UPDATE_APPLICATION_FAIL],
    promise: function promise(client) {
      return client.post(url, {
        data: {
          userId: userId,
          moduleId: moduleId,
          state: modState
        }
      });
    }
  };
}

/*
  return load from database ELSE load initial state of application
 */
function loadModuleApp(userId, moduleId, appId) {
  var url = '/module' + moduleId + '/app' + appId + '/load';
  return {
    types: [LOAD_APPLICATION, LOAD_APPLICATION_SUCCESS, LOAD_APPLICATION_FAIL],
    promise: function promise(client) {
      return client.get(url);
    }
  };
}

function loadModuleAct(userId, moduleId, actId) {
  var url = '/module' + moduleId + '/act' + actId + '/load';
  return {
    types: [LOAD_APPLICATION, LOAD_ACT_SUCCESS, LOAD_APPLICATION_FAIL],
    promise: function promise(client) {
      return client.get(url);
    }
  };
}

/*
  return state for loaded module for ID TODO
 */
function loadModule(userId, moduleId) {
  var url = '/module' + moduleId + '/load';
  return url;
}

/*
  return inital state for all modules
 */
function loadAllModules(userId) {
  // console.log(userId.auth.user.userId);
  // userId = userId.auth.user.userId; // getState();
  var url = '/loadModules';
  return {
    types: [LOAD_ALL, LOAD_ALL_SUCCESS, LOAD_APPLICATION_FAIL],
    promise: function promise(client) {
      return client.get(url, {
        params: {
          userId: userId
        }
      });
    }
  };
}

function isLoaded(globalState) {
  return globalState.moduleData && globalState.moduleData.loaded;
}

/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/moduleData.js
// module id = 18
// module chunks = 0